module.exports = "/_next/static/images/nofee-a50f3542d9f9444d61aea834639629fd.svg";